/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-04 11:19:00
 * @LastEditors: Json Chen
 * @LastEditTime: 2023-03-07 09:29:11
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/ReadyToPack/index.tsx
 */
//import css from './css.module.less';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import Category from '@/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Components/Category';
import Detail from '@/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Components/PackageDetail';
import { handleOnFormatStoreTimeAndDateWithTimezone } from 'src/tools/tools';
import { get } from 'lodash';
import React from 'react';
import ModalHoc from 'src/constrains/ModalHOC';
import { packParcel, printPackingSlip } from 'src/request/order';
import { msg } from 'src/tools/message';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const ReadyToPack = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { modalOp, disabled, disablePrint, decimalPosition, taxIncluded } =
    props;
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;
  const { data, orderNo, onUpdate, onUndo } = props;
  return (
    <Category
      decimalPosition={decimalPosition}
      taxIncluded={taxIncluded}
      onUpdate={onUpdate}
      title={getI18n(`allOrders.orderDetail.readytopack_return_category_title`)}
      data={data.map((i) => {
        const image = get(i, 'images.0.url');
        const pickedDate = get(i, 'pickedDate', null);
        const pickDate = handleOnFormatStoreTimeAndDateWithTimezone(pickedDate);
        const parcelNo = get(i, 'parcelNo');
        const uuid = get(i, 'uuid');
        return {
          uuid,
          image,
          sku: `${orderNo}-${parcelNo}`,
          options: [
            {
              title: getI18n(
                `allOrders.orderDetail.readytoship_returndata_options_pickedtitle`,
              ),
              content: pickDate || '-',
            },
          ],
          btns: [
            {
              text: getI18n(
                `allOrders.orderDetail.readytopack_returndata_packbtns_text`,
              ),
              disabled: disabled,
              onClick: () => {
                setShowModal(true);
                setModalTitle(
                  getI18n(
                    `allOrders.orderDetail.readytopack_returndata_packbtns_setmodaltitle`,
                  ),
                );
                setModalContent(
                  <Detail
                    onCancel={onModalCancel}
                    uuid={uuid}
                    isPacking
                    decimalPosition={decimalPosition}
                    taxIncluded={taxIncluded}
                    onConfirm={(data) => {
                      packParcel(data).then((res) => {
                        onUpdate(res);
                        onModalCancel();
                        msg.destroy();
                        msg.success(
                          getI18n(
                            `allOrders.orderDetail.readytopack_returndata_packbtns_msgsuccess`,
                          ),
                        );
                      });
                    }}
                  />,
                );
              },
            },
            {
              text: getI18n(
                `allOrders.orderDetail.readytopack_returndata_printbtns_text`,
              ),
              disabled: disablePrint,
              onClick: () => printPackingSlip(uuid),
            },
          ],
          ...(!disabled && {
            dropOptions: [
              {
                key: uuid,
                label: getI18n(
                  `allOrders.orderDetail.readytopack_returndata_dropoptions_label`,
                ),
                onClick: () => {
                  setShowModal(true);
                  setModalTitle(
                    getI18n(
                      `allOrders.orderDetail.readytopack_returndata_dropoptions_label`,
                    ),
                  );
                  setModalContent(
                    <div>
                      <p className={css.subscribeCustomerContent}>
                        {getI18n(
                          `allOrders.orderDetail.readytopack_returndata_dropoptions_setmodalcontent`,
                        )}
                      </p>
                      <ModalFooter
                        okText={getI18n(
                          `allOrders.orderDetail.readytopack_returndata_dropoptions_oktext`,
                        )}
                        onOk={() => {
                          onUndo(uuid, (res) => {
                            onUpdate(res);
                            msg.success(
                              getI18n(
                                `allOrders.orderDetail.readytopack_returndata_dropoptions_msgsuccess`,
                              ),
                            );
                          });
                        }}
                        onCancel={() => setShowModal(false)}
                      />
                    </div>,
                  );
                },
              },
            ],
          }),
        };
      })}
    />
  );
};
export default ModalHoc(ReadyToPack, { width: 980 });
